import {
  ProviderLoggerActionNames,
  ProviderLoggerMessages,
} from '@/features/game-window-integration/types';
import {
  DdEventCategory,
  DdEventType,
  Logger,
} from '@/features/logging/logger';
import { processPayload } from '@/utils/process-error-payload';

export const handleUnknownEvent = (fullPayload) => {
  Logger.rumAction({
    name: ProviderLoggerActionNames.UNKNOWN_EVENT,
    description: ProviderLoggerMessages.UNKNOWN_EVENT,
    useCase: DdEventCategory.ProviderMessages,
    eventType: DdEventType.Info,
    context: {
      stringifiedPayload: processPayload(fullPayload),
    },
  });
};

export const handleUnknownMapping = (fullPayload, event) => {
  Logger.rumAction({
    name: ProviderLoggerActionNames.UNKNOWN_MAPPING,
    description: ProviderLoggerMessages.UNKNOWN_MAPPING,
    useCase: DdEventCategory.ProviderMessages,
    eventType: DdEventType.Info,
    context: {
      event,
      stringifiedPayload: processPayload(fullPayload),
    },
  });
};
